import { defineStore } from 'pinia';
import { localStg } from '@/utils/storage';
import { getLockScreenStatus } from './helpers';

// 长时间不操作默认锁屏时间
const initTime = 60 * 30; // 30min

export type LockscreenState = {
  isLock: boolean; // 是否锁屏
  lockTime: number;
};

export const useLockscreenStore = defineStore('lockscreen-store', {
  state: (): LockscreenState => ({
    isLock: getLockScreenStatus(),
    lockTime: 0
  }),
  actions: {
    /** 重置锁屏的store */
    resetLockScreenStore() {
      this.setLock(false);
    },
    setLock(item: boolean) {
      this.isLock = item;
      localStg.set('isLockScreen', item);
    },
    setLockTime(lockTime = initTime) {
      this.lockTime = lockTime;
    }
  }
});
